import React from 'react';
import { Card, CardContent } from './ui/card';
import { useNavigate } from 'react-router-dom';
import './CardGrid.css';

// Map of main category images
const mainCategoryImages = {
  'tecnal-av-main': '/assets/tecnal/main/av.webp',
  'tecnal-aa-main': '/assets/tecnal/main/aa.webp',
  'tecnal-ag-main': '/assets/tecnal/main/ag.webp',
  'tecnal-mp-main': '/assets/tecnal/main/mp.webp',
  'tecnal-em-main': '/assets/tecnal/main/em.webp',
  'tecnal-ref-rotativo': '/assets/tecnal/referencias/tecnal_rotativo_1.webp',
  'tecnal-ref-expander': '/assets/tecnal/referencias/tecnal_expander_1.webp',
  'tecnal-ref-secadora': '/assets/tecnal/referencias/tecnal_secadora_1.webp'
};

// Helper to get card image
const getCardImage = (card) => {
  // Check if it's a main category image
  if (card.imageKey && mainCategoryImages[card.imageKey]) {
    return mainCategoryImages[card.imageKey];
  }
  
  // If card has images array with actual images, use the first one
  if (card.images && card.images.length > 0) {
    // Determine category from href
    if (card.href?.includes('aceite-vegetal')) {
      return `/assets/tecnal/av/${card.images[0]}`;
    }
    if (card.href?.includes('alimentacion-animal')) {
      return `/assets/tecnal/aa/${card.images[0]}`;
    }
    if (card.href?.includes('almacenamiento-de-granos')) {
      return `/assets/tecnal/ag/${card.images[0]}`;
    }
    if (card.href?.includes('movimiento-portuario')) {
      return `/assets/tecnal/mp/${card.images[0]}`;
    }
    if (card.href?.includes('etanol-de-maiz')) {
      return `/assets/tecnal/em/${card.images[0]}`;
    }
    if (card.href?.includes('referencias')) {
      return `/assets/tecnal/referencias/${card.images[0]}`;
    }
  }
  // Fallback to placeholder
  return `https://via.placeholder.com/400x250/003D4C/ffffff?text=${encodeURIComponent(card.title)}`;
};

const CardGrid = ({ cards }) => {
  const navigate = useNavigate();

  return (
    <div className="card-grid">
      {cards.map((card, idx) => (
        <Card
          key={idx}
          className="card-grid-item"
          data-testid={`card-${card.title.toLowerCase().replace(/\s+/g, '-')}`}
          onClick={() => card.href && navigate(card.href)}
        >
          <CardContent className="card-grid-content">
            <div className="card-grid-image">
              <img
                src={getCardImage(card)}
                alt={card.title}
                loading="lazy"
                className="card-image"
                onError={(e) => {
                  e.target.src = `https://via.placeholder.com/400x250/003D4C/ffffff?text=${encodeURIComponent(card.title)}`;
                }}
              />
            </div>
            <h3 className="card-grid-title">{card.title}</h3>
            <p className="card-grid-description">{card.description}</p>
            {card.href && <span className="card-grid-arrow">→</span>}
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default CardGrid;
